module.exports = __webpack_public_path__ + "img/survive.b08b568d.png";